import random from 'toxilibs/random.js'
import Level from '../../core/level.js'

const level = new Level({
    name: 'test_formula',
    dependencies: []
})


level.addQuestion({
    generator: function (q) {
        q.addMathFormula('2^2 xx 2^3')
        q.addText('\n')
        q.addAnswerFormula('2^?')
        q.answer = 42
    }
})


level.addQuestion({
    generator: function (q) {
        let a = random.intBetween(2, 7)
        let b = random.intBetween(2, 7)

        q.addMathFormula('(2^' + a + '*2^' + b + ')')
        q.addText('\n')
        q.addMathFormula('2^?')

        let exposant = a + b

        q.answer = [
            '2 puissance ' + exposant,
            '2 puissance ' + a + '+' + b,
            Math.pow(2, exposant)
        ]
    },
    times: 1
})


level.addQuestion({
    generator: function (q) {
        q.addText('\\\\color{red}')
        q.addMathFormula('\\color{red}sum_(i=1)^n i^3=((n(n+1))/2)^2')  //You can set a particular color by prefix a element by \\color{#...}element
        q.addText('\\\\color{#0d96c6}[]')
        q.addMathFormula('\\color{#0d96c6}[sum_(i=1)^n i^3]=((n(n+1))/2)^2')    //Or you can set a color to a group of element by using []
        q.answer = 42
    },
    times: 5
})


export default level

